import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-pcomp-site-call-intercepter',
	templateUrl:'./SiteCallIntercepterPluginCompPage.html',
	styles: [],
	styleUrls:['./SiteCallIntercepterPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class SiteCallIntercepterPluginCompPage
{
	mdContent_1100 = `\`\`\`java
import com.jwebmp.client.SiteCallIntercepter;
\`\`\``;
	mdContent_1101 = `\`\`\`java
public class LoggingInterceptor implements SiteCallIntercepter&lt;LoggingInterceptor&gt; {
    @Override
    public void intercept(AjaxCall&lt;?&gt; call, AjaxResponse&lt;?&gt; response) {
        log.info("Call from: " + call.getComponentId());
    }
}
\`\`\``;
}
